module.exports = __webpack_public_path__ + "media/images/rbp-555304ed81d3ec147e9a4cbd60b07f57.jpg";